export const routes = {
    START: 'start',
    FOUNDATIONS: 'foundations',
    COMPONENTS: 'components',
    MAP: 'map',
    CHARTS: 'charts',
    TEMPLATES: 'templates',
    UTILITIES: 'utilities',
    INTERNAL: 'internal',
} as const;
